import type * as pf from '@amirada/lib-shared'
import { PfCmdType } from '@amirada/lib-shared'
import type * as tp from '@base/utils/types'
import { ut_capStore, ut_createParamDataString } from '@base/utils/utils'
import { usePfinderAPI } from '@base/composables/pfinderAPI'
import { useAppIndexStore } from '@base/stores/indexStore'
import { def_listLimit } from '@base/utils/constants'

export const useSearchStore = defineStore('searchStore', () => {
  const state: { [key: string]: pf.SearchResult } = reactive({})

  const indexStore = useAppIndexStore()
  const pfinderAPI = usePfinderAPI()

  function cacheKey(paramData: tp.IParamData): string {
    return [ut_createParamDataString(paramData),
      paramData.queryUrlServer.term,
      paramData.page].join('#')
  }
  async function callSearchData(paramData: tp.IParamData, cursor: number = 0, limit: number = def_listLimit): Promise<void> {
    const searchData = getSearchData(paramData)
    const loadMore: boolean = (searchData?.slice.cursor || 0) < cursor
    if (!searchData || loadMore) {
      await indexStore.withLoading(async () => {
        const args: pf.PfCmd<PfCmdType.SEARCH>['arg'] = {
          term: paramData.queryUrlServer.term || '',
          cursor,
          limit,
        }
        const data: tp.IFetchData = {
          paramData,
          noUrlParams: true,
        }
        const res = await pfinderAPI.fetchData(PfCmdType.SEARCH, args, data)
        if (res && res.result) {
          setSearchData(paramData, loadMore, res.result)
        }
      })
    }
  }

  async function callSuggestData(paramData: tp.IParamData, term: string, limit: number = def_listLimit): Promise<string[]> {
    const args: pf.PfCmd<PfCmdType.SUGGEST>['arg'] = {
      term,
      limit,
    }
    const data: tp.IFetchData = {
      paramData,
      noUrlParams: true,
    }
    const res = await pfinderAPI.fetchData(PfCmdType.SUGGEST, args, data)
    if (res) {
      return res.result
    }
    else {
      return []
    }
  }

  function setSearchData(paramData: tp.IParamData, loadMore: boolean, data: pf.SearchResult): void {
    let searchData: pf.SearchResult | undefined
    // Add to existing data
    if (loadMore) {
      searchData = getSearchData(paramData)
      if (searchData) {
        searchData.found = searchData.found.concat(data.found)
        searchData.slice = data.slice
      }
      else {
        searchData = data
      }
      // New search data
    }
    else {
      searchData = data
    }
    ut_capStore(state)
    state[cacheKey(paramData)] = searchData
  }

  function getSearchData(paramData: tp.IParamData): pf.SearchResult | undefined {
    return state[cacheKey(paramData)]
  }

  return {
    state,
    callSearchData,
    callSuggestData,
    getSearchData,
  }
})
